import service from '@/services/superaccess'

const visited = {
  state: {
    visited_modal: false
  },
  mutations: {
    updateStatusVisitedModal (context, status) {
      context.visited_modal = status
    }
  },
  getters: {
    getStatusVisitedModal (context) {
      return context.visited_modal
    }
  },
  actions: {
    retrieveDetailsVisited (context, payload) {
      return service.get('/api/visited/new', context)
    },
    saveVisited (context, payload) {
      return service.post('/api/visited/create', context, { visited: payload })
    },
    changeVisitedStatus (context, payload) {
      return service.patch('/api/visited/inactive', context, payload)
    },
    updateVisited (context, payload) {
      return service.patch('/api/visited/modify', context, { visited: payload })
    },
    checkIdentificationNumber (context, payload) {
      return service.post('/api/visited/check_iden_number', context, { payload })
    },
    setStatusVisitedModal (context, payload) {
      context.commit('updateStatusVisitedModal', payload)
    }
  }
}

export default visited



// WEBPACK FOOTER //
// app/javascript/src/store/visited.js